import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Query defaults.
 *
 * Admin data is operational, so it is refetched on focus but not polled
 * aggressively. Authentication and authorisation failures are never retried —
 * retrying a 401 just delays the redirect to the login screen.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.status === 401 || error.status === 403 || error.status === 404) return false;
          if (error.status === 429) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
